import React from 'react';
import { Route, Routes } from 'react-router-dom';

import RouteTracker from './components/analytics/RouteTracker';
import { PaydleDashboard, PlayPaydle } from './components/Paydle';
import AtmDetail from './pages/AtmDetail';
import CreateAtm from './pages/CreateAtm';
import CreatePaydle from './pages/CreatePaydle';
import CreateWheel from './pages/CreateWheel';
import EditAtm from './pages/EditAtm';
import EditWheel from './pages/EditWheel';
import ExploreAtms from './pages/ExploreAtms';
import ExploreWheels from './pages/ExploreWheels';
import FAQ from './pages/FAQ';
import Features from './pages/Features';
import Home from './pages/Home';
import HowItWorks from './pages/HowItWorks';
import MyAtms from './pages/MyAtms';
import MyPaydles from './pages/MyPaydles';
import MyWheels from './pages/MyWheels';
import Privacy from './pages/Privacy';
import Profile from './pages/Profile';
import ResetPassword from './pages/ResetPassword';
import SharedAtmView from './pages/SharedAtmView';
import SharedWheelView from './pages/SharedWheelView';
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import Terms from './pages/Terms';
import WheelDetail from './pages/WheelDetail';

// Placeholder components for routes

const WishlistsPage = () => (
  <div className="container mx-auto px-4 py-8">
    <h1 className="text-3xl font-bold mb-6">Wishlists</h1>
    <p>This page will display wishlists and allow users to create new ones.</p>
  </div>
);

const TasksPage = () => (
  <div className="container mx-auto px-4 py-8">
    <h1 className="text-3xl font-bold mb-6">Tasks</h1>
    <p>This page will display tasks and allow users to browse by category.</p>
  </div>
);

// Placeholder removed - using real CreateWheel component now

const NotFound = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-100">
    <div className="text-center bg-white p-8 rounded-lg shadow-lg max-w-md">
      <div className="mb-6">
        <svg
          width="120"
          height="120"
          viewBox="0 0 120 120"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="mx-auto animate-spin-slow"
        >
          <circle
            cx="60"
            cy="60"
            r="54"
            stroke="#EC4899"
            strokeWidth="12"
            strokeDasharray="15 15"
          />
          <circle cx="60" cy="60" r="30" fill="#8B5CF6" className="filter drop-shadow-lg" />
        </svg>
      </div>
      <h1 className="text-6xl font-bold text-primary mb-4">404</h1>
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Page Not Found</h2>
      <p className="text-gray-600 mb-8">
        The page you&apos;re looking for doesn&apos;t exist or has been moved.
      </p>
      <div className="flex flex-col sm:flex-row justify-center gap-4">
        <a
          href="/"
          className="bg-primary hover:bg-primary-dark text-white font-bold py-2 px-4 rounded transition-colors"
        >
          Go Home
        </a>
        <a
          href="/wheels"
          className="bg-secondary hover:bg-secondary-dark text-white font-bold py-2 px-4 rounded transition-colors"
        >
          Explore Wheels
        </a>
      </div>
    </div>
  </div>
);

const App: React.FC = () => {
  return (
    <>
      <RouteTracker />
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route path="/wheels" element={<ExploreWheels />} />
        <Route path="/wheels/:id" element={<WheelDetail />} />
        <Route path="/features" element={<Features />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        {/* Authentication routes */}
        <Route path="/sign-in" element={<SignIn />} />
        <Route path="/sign-up" element={<SignUp />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/profile" element={<Profile />} />
        {/* Feature routes */}
        <Route path="/wishlists" element={<WishlistsPage />} />
        <Route path="/tasks" element={<TasksPage />} />
        <Route path="/create-wheel" element={<CreateWheel />} />
        <Route path="/edit-wheel/:id" element={<EditWheel />} />
        <Route path="/my-wheels" element={<MyWheels />} />
        <Route path="/shared/:shareId" element={<SharedWheelView />} />
        <Route path="/shared/:shareId/:accessCode" element={<SharedWheelView />} />
        {/* ATM routes */}
        <Route path="/atms" element={<ExploreAtms />} />
        <Route path="/atm/:id" element={<AtmDetail />} />
        <Route path="/shared-atm/:shareId" element={<SharedAtmView />} />
        <Route path="/shared-atm/:shareId/:accessCode" element={<SharedAtmView />} />
        <Route path="/create-atm" element={<CreateAtm />} />
        <Route path="/edit-atm/:id" element={<EditAtm />} />
        <Route path="/my-atms" element={<MyAtms />} />
        {/* Paydle routes */}
        <Route path="/my-paydles" element={<MyPaydles />} />
        <Route path="/create-paydle" element={<CreatePaydle />} />
        <Route path="/paydle/play/:shareId" element={<PlayPaydle />} />
        <Route path="/paydle/manage/:accessToken" element={<PaydleDashboard />} />
        {/* 404 route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};
export default App;
